<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="36"
      viewBox="0 0 54 36"
    >
      <path
        id="Icon_ionic-md-menu"
        data-name="Icon ionic-md-menu"
        d="M4.5,45h54V39H4.5Zm0-15h54V24H4.5Zm0-21v6h54V9Z"
        transform="translate(-4.5 -9)"
      />
    </svg>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
